import { get } from '..';
import routes from './routes';

const DashboardServices = {
  getUserDashboard: async (from, to) => {
    const data = await get(routes.getUserDashboard, { from, to });
    return data;
  },
  getAdminDashboard: async (period = 'monthly', from, to) => {
    const data = await get(routes.getAdminDashboard, { period, from, to });
    return data;
  },
};

export default DashboardServices;
